import { createSelector } from 'reselect'

import {
  selectModalProps,
  selectMailboxChangeFilter,
} from 'selectors/modals_base'

import { selectAllRecipientIds } from 'ducks/drafts'

import { selectPossibleMailboxesForChange } from 'selectors/mailboxes'
import {
  selectSuggestedUsers,
  selectLastUserSearchResultsSize,
} from 'selectors/users'
import { curry } from 'util/functions'
import { caselessMatch, isValidEmail } from 'util/strings'

export * from 'selectors/modals_base'

export const selectCurrentModalTab = createSelector(
  selectModalProps,
  props => props.activeTab
)

export const selectRecipientQuery = createSelector(
  selectModalProps,
  props => props.query
)

export const selectIsRecipientQueryValidEmail = createSelector(
  selectRecipientQuery,
  query => isValidEmail(query)
)

export const selectSelectedCcRecipient = createSelector(
  selectModalProps,
  props => props.selectedCcRecipient || undefined
)

export const selectSelectedBccRecipient = createSelector(
  selectModalProps,
  props => props.selectedBccRecipient || undefined
)

export const selectIsSearchingRecipients = createSelector(
  selectModalProps,
  props => props.searchingRecipients
)

export const selectSuggestedRecipients = createSelector(
  selectSuggestedUsers,
  selectAllRecipientIds,
  (suggested, recipientIds) => {
    return suggested.filter(object => {
      return recipientIds.indexOf(object.id) < 0
    })
  }
)

export const selectFilteredCcRecipients = createSelector(
  selectSelectedCcRecipient,
  selectSuggestedRecipients,
  (selected, suggested) => {
    return selected ? [selected] : suggested
  }
)

export const selectFilteredBccRecipients = createSelector(
  selectSelectedBccRecipient,
  selectSuggestedRecipients,
  (selected, suggested) => {
    return selected ? [selected] : suggested
  }
)

export const selectLastFilteredCcRecipientsSize = selectLastUserSearchResultsSize

export const selectLastFilteredBccRecipientsSize = selectLastUserSearchResultsSize

export const selectFilteredMailboxes = createSelector(
  selectPossibleMailboxesForChange,
  selectMailboxChangeFilter,
  (mailboxes, term) => {
    if (!term || term === '') return mailboxes
    const matches = curry(caselessMatch)(term)
    const result = mailboxes.filter(
      mailbox =>
        matches(mailbox.name) || (mailbox.email && matches(mailbox.email))
    )
    return result
  }
)
